import { createStore } from "vuex";

export default createStore({
  state: {
    prohibitedAction: [],
    prohibitedPages: [],
    trackingEventDataSetting: {},
    systemAuId: "",
    changePhoneNumber: {},
    identityId: '',
    cognitoToken: '',
  },
  getters: {
    getProhibitedAction(state) {
      return state.prohibitedAction;
    },
    getProhibitedPages(state) {
      return state.prohibitedPages;
    },
    isProhibitedDeposit(state) {
      return state.prohibitedAction?.indexOf("deposit") > -1;
    },
    isProhibitedPrepaid(state) {
      return state.prohibitedAction?.indexOf("prepaid") > -1;
    },
    isProhibitedSmbc(state) {
      return state.prohibitedAction?.indexOf("smbc") > -1;
    },
    isProhibitedGelato(state) {
      return state.prohibitedAction?.indexOf("gelato") > -1;
    },
    isProhibitedSeven(state) {
      return state.prohibitedAction?.indexOf("seven") > -1;
    },
    isProhibitedWakai(state) {
      return state.prohibitedAction?.indexOf("wakai") > -1;
    },
    getTrackingEventDataSetting(state) {
      return state.trackingEventDataSetting;
    },
    getSystemAuId(state) {
      return state.systemAuId;
    },
    getIdentityId(state) {
      return state.identityId;
    },
    getCognitoToken(state) {
      return state.cognitoToken;
    },
  },
  mutations: {
    setProhibitedAction(state, prohibitedAction) {
      state.prohibitedAction = prohibitedAction;
    },
    setProhibitedPages(state, prohibitedPages) {
      state.prohibitedPages = prohibitedPages;
    },
    setTrackingEventDataSetting(state, trackingEventDataSetting) {
      state.trackingEventDataSetting = trackingEventDataSetting;
    },
    setSystemAuId(state, systemAuId) {
      state.systemAuId = systemAuId;
    },
    setChangePhoneNumber (state, changePhoneNumber) {
      state.changePhoneNumber = changePhoneNumber
    },
    setIdentityId (state, identityId) {
      state.identityId = identityId
    },
    setCognitoToken (state, cognitoToken) {
      state.cognitoToken = cognitoToken
    },
  },
  actions: {
    setProhibitedAction({ commit }, prohibitedAction) {
      commit("setProhibitedAction", prohibitedAction);
    },
    setProhibitedPages({ commit }, prohibitedPages) {
      commit("setProhibitedPages", prohibitedPages);
    },
    setTrackingEventDataSetting({ commit }, trackingEventDataSetting) {
      commit("setTrackingEventDataSetting", trackingEventDataSetting);
    },
    setSystemAuId({ commit }, systemAuId) {
      commit("setSystemAuId", systemAuId);
    },
    setIdentityId({ commit }, identityId) {
      commit("setIdentityId", identityId);
    },
    setCognitoToken({ commit }, cognitoToken) {
      commit("setCognitoToken", cognitoToken);
    },
  },
});
